import axios from 'axios';

import { PROFILE_NOTIFICATIONS_V2 } from '../endpointsConst';

export interface NotificationSettings {
  deal_request_email_notifications: boolean;
}

const NotificationSettingsService = {
  getSettings: () => axios.get<NotificationSettings>(PROFILE_NOTIFICATIONS_V2),

  updateSettings: (data: Partial<NotificationSettings>) => axios.patch<NotificationSettings>(PROFILE_NOTIFICATIONS_V2, data),
};

export { NotificationSettingsService };
